var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductDetail',{attrs:{"type":"edit","submitting":_vm.submitting,"values":_vm.data,"default-gtip":_vm.defaultGtip},on:{"submit":_vm.submit,"defaultGtip":_vm.setDefaultGtip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }